import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { Link, useLocation, useParams } from "react-router-dom";
import { LoggedInView } from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import {
    createSMSSender,
    getCurrentSMSSender,
    resetUpdateSMSSenderStatus,
    updateSMSSender,
} from "../../store/reducers/SMSSendersSlice";
import { RequestStatus } from "../../utils/Enums";
import ElogTextarea from "../common/form/ElogTextarea";
import {FormikProvider, useFormik, Field, Form} from "formik";

interface ModifySMSSenderScreenProps {}

export interface ModifySMSSenderFormProps {
    name: string;
}

export const ModifySMSSenderScreen: React.FC<ModifySMSSenderScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const { id } = useParams();

    const SMSSendersState = useAppSelector(
        (state) => state.SMSSenders
    );

    const requestStatus: RequestStatus =
        SMSSendersState.updateSMSSenderStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "SMS saatjad", url: "/sms-senders" },
        { text: "SMS saatja muutmine", url: `/sms-senders/${id}/modify` },
    ];

    useEffect(() => {
        dispatch(resetUpdateSMSSenderStatus());
    }, [location]);

    useEffect(() => {
        dispatch(getCurrentSMSSender({ id }));
    }, [id]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            name: SMSSendersState?.currentSMSSender?.name ?? "",
        },
        onSubmit: (values: any) => {
            dispatch(updateSMSSender({ id, data: values }));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && (
                <div className="message msg-ok">
                    <div>
                        <h2>Andmed muudetud</h2>
                    </div>
                </div>
            )}
            {requestStatus === RequestStatus.Failed &&
            SMSSendersState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {SMSSendersState.errors.map((error, index) => (
                            <span key={index}>
                                    {error}
                                <br />
                                </span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>SMSi saatja andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Nimi"
                                name="name"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Muuda</strong>
                                    </span>
                            </button>
                            <Link to="/offline-reasons">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};